import Loading from 'components/common/Loading';
import useNotiBox from 'hooks/service/useNotiBox';
import { boxStyle } from 'lib/styles/index';
import styled from 'styled-components';

const NotiBoxRow = ({ noti }) => {
  const { createdAt, store, title } = noti;
  const [date, time] = createdAt.split(' ');
  const [company, place] = store.split(' ');

  return (
    <NotiBoxRowBlock>
      <div className="noti-box-row-row gray">{date}</div>
      <div className="noti-box-row-row">
        <div className="noti-box-row-row-left">
          <div>{company}</div>
          <div>{place}</div>
        </div>
        <div className="noti-box-row-row-right">
          <div>{title}</div>
          <div className="gray time">{time.slice(0, -3)}</div>
        </div>
      </div>
    </NotiBoxRowBlock>
  );
};

const NotiBoxRowBlock = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;
  & + & {
    margin-top: 0.5rem;
  }

  .noti-box-row-row {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0.3rem;
  }

  .noti-box-row-row-left {
    width: 30%;
    display: flex;
    flex-direction: column;
  }

  .noti-box-row-row-right {
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    div + div {
      margin-top: 0.3rem;
    }
  }

  .time {
    width: 100%;
    text-align: end;
  }
`;

const NotiBox = ({ errorType, startDate, endDate }) => {
  const { data, hasNextPage, isFetchingNextPage, status, error, containerRef } =
    useNotiBox(errorType, startDate, endDate);

  return (
    <NotiBoxBlock>
      {error?.response.status === 500 ? (
        <div style={{ textAlign: 'center' }}>오류 발생...</div>
      ) : error?.response.status === 401 ? null : data?.pages[0].result
          .length === 0 ? (
        <div className="noti-box-error">알림 내역이 없습니다</div>
      ) : status === 'loading' ? (
        <Loading />
      ) : (
        status === 'success' &&
        data?.pages.map(page =>
          page?.result.map((noti, i) => <NotiBoxRow key={i} noti={noti} />),
        )
      )}
      {isFetchingNextPage ? (
        <Loading small />
      ) : hasNextPage ? (
        <div ref={containerRef} />
      ) : (
        <div />
      )}
    </NotiBoxBlock>
  );
};

export default NotiBox;

const NotiBoxBlock = styled.div`
  ${boxStyle}
  max-height: 460px;
  margin-top: 1rem;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;

  .noti-box-error {
    padding: 1.5rem 0;
    text-align: center;
    font-weight: bold;
  }

  .gray {
    color: rgba(0, 0, 0, 0.5);
  }
`;
